"use client"
import "./css/cascading-text.css"

const CascadingText = ({ text, delayIncrement = 10 }) => {
  if (!text) return null

  let charCount = 0

  return (
    <span className="cascading-text-container">
      {text.split(" ").map((word, wordIndex) => {
        // Cada palabra se envuelve en un span para evitar que se rompa.
        return (
          <span key={wordIndex} className="cascading-word-wrapper">
            {word.split("").map((char, charInWordIndex) => {
              const style = {
                animationDelay: `${(charCount + charInWordIndex) * delayIncrement}ms`,
              }
              return (
                <span key={charInWordIndex} className="cascading-char" style={style}>
                  {char}
                </span>
              )
            })}
            {/* Agrega un espacio de no ruptura después de cada palabra */}
            {"\u00A0"}
            {/* Este es un truco para incrementar dentro de JSX y devolver null */}
            {(charCount += word.length + 1) && null}
          </span>
        )
      })}
    </span>
  )
}

export default CascadingText
